<script setup>
import { useRoute } from "vue-router";
import BaseHeader from "./components/BaseHeader.vue";
import BaseFooter from "./components/BaseFooter.vue";
import BaseNavigator from "./components/BaseNavigator.vue";
import SubTitle from "./components/SubTitle.vue";
import { computed, ref } from "vue";
import { useReloadKey } from "./utils/reloader";

const route = useRoute();
const reloadKey = useReloadKey()
const exceptRoutes = ['/login', '/admin', '/resources', '/notice', '/apply', '/inquiry'];
const viewKey = computed(() => route.fullPath + ':' + reloadKey.value)
const isPopupRoute = computed(() => route.path.startsWith('/popup'));
const isMaintenance = ref(false);  // 점검중이면 true, 아니면 false

const isExceptRoute = computed(() =>
  exceptRoutes.some(path => route.path.startsWith(path))
);

</script>

<template>
  <div id="app">
    <template v-if="isMaintenance && !isExceptRoute">
      <!-- 점검 페이지 단독 화면 -->
      <div class="maintenance-container">
        <h1>점검중입니다.</h1>
        <p>더 나은 서비스를 위해 홈페이지 점검중입니다.<br>잠시 후 다시 접속해주세요.</p>
        <h2>14:00 ~ 15:00</h2>
      </div>
    </template>
    <template v-else>
      <!-- 기존 전체 레이아웃 -->
      <BaseHeader v-if="!isPopupRoute" />
      <main :class="['main', { 'no-padding': route.path === '/' }]">
        <SubTitle v-if="!isPopupRoute"></SubTitle>
        <router-view :key="viewKey"/>
      </main>
      <BaseFooter v-if="!isPopupRoute"/>
      <BaseNavigator v-if="!isPopupRoute"/>
    </template>
  </div>
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Noto Sans KR", sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 앱의 최소 높이를 화면 높이로 설정 */
}

.maintenance-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  font-size: 1.3rem;
  background: #fafbff;
}
.maintenance-container h1 {
  font-size: 2.5rem;
  color: #a22;
  margin-bottom: 24px;
}

/* 기본 main 영역 */
.main {
  flex-grow: 1; /* main이 화면의 나머지 공간을 차지하도록 설정 */
  padding-top: 80px; /* 헤더 영역을 위한 여백 */
  overflow-y: auto; /* 콘텐츠가 많을 경우 스크롤이 생기도록 설정 */
}

/* 홈에서는 헤더와 겹치게 하기 위해 padding 제거 */
.main.no-padding {
  padding-top: 0 !important;
}
</style>
